import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../shared/ApiService/api.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReleaseNotesService {

  private readonly baseUrl = `${environment.base_url}/release-history`;

  constructor(private apiService: ApiService) {}

  /**
   * Get Public Release History
   */
  getPublishedReleaseHistory(params?: any): Observable<any> {
    return this.apiService.get(
      `${this.baseUrl}/public`,
      params
    );
  }
}
